import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-enterprise',
  templateUrl: './create-enterprise.component.html',
  styleUrls: ['./create-enterprise.component.scss']
})
export class CreateEnterpriseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
